import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-9" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "sm:col-span-1" }, null, -1)
const _hoisted_3 = { class: "sm:col-span-4 main-content" }
const _hoisted_4 = { class: "question-label" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = ["placeholder"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BackNextButtons = _resolveComponent("BackNextButtons")!
  const _component_ScreenWrapper = _resolveComponent("ScreenWrapper")!

  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["screen-content", _ctx.config.wrapperClasses])
  }, [
    _createVNode(_component_ScreenWrapper, {
      "class-name": "pt-0",
      next: _ctx.next,
      screen: _ctx.screen,
      "hide-arrow": ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("span", null, _toDisplayString(_ctx.config.title), 1)
            ]),
            _createElementVNode("p", {
              class: "mt-4",
              innerHTML: _ctx.$t(_ctx.config.question, {name: _ctx.state.nickname.value})
            }, null, 8, _hoisted_5),
            _withDirectives(_createElementVNode("textarea", {
              placeholder: _ctx.$t(_ctx.config.placeholder, {name: _ctx.state.nickname.value}),
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.response) = $event)),
              class: "mt-4 mb-4 w-full border-2 border-project rounded-sm text-sm",
              rows: "5"
            }, "\n                   ", 8, _hoisted_6), [
              [_vModelText, _ctx.response]
            ]),
            _createVNode(_component_BackNextButtons, {
              "go-to": _ctx.saveAndNext,
              "next-screen": _ctx.config.screenNext,
              "button-class": "action-button mt-auto"
            }, null, 8, ["go-to", "next-screen"])
          ]),
          _createElementVNode("div", {
            class: "sm:col-span-4 h-full min-h-50vh flex-col items-center flex",
            style: _normalizeStyle(`background-image: ${_ctx.config.bgImage}; background-size: cover;  background-repeat: no-repeat; background-position: center; ${_ctx.config.bgStyles}`)
          }, null, 4)
        ])
      ]),
      _: 1
    }, 8, ["next", "screen"])
  ], 2))
}